import { createFeatureSelector, createSelector } from '@ngrx/store';
import { customerAccountFeatureKey } from '../reducers';
import { CustomerAccountState } from '../reducers/customer-account.reducer';

export const selectCustomerAccountState =
  createFeatureSelector<CustomerAccountState>(customerAccountFeatureKey);

export const selectCustomerAccount = createSelector(
  selectCustomerAccountState,
  (state) => state.customerAccount
);

export const selectCustomerLanguage = createSelector(
  selectCustomerAccountState,
  (state: CustomerAccountState) => state.language
);

export const selectCustomer = createSelector(
  selectCustomerAccountState,
  (state: CustomerAccountState) => state.customerAccount?.getSelectedCustomer()
);

export const selectIsUserSE = createSelector(
  selectCustomerAccountState,
  (state: CustomerAccountState) => state.customerAccount?.isSE() ?? false
);

export const selectIsUserPayer = createSelector(
  selectCustomerAccountState,
  (state: CustomerAccountState) =>
    state.customerAccount?.getSelectedCustomer().payer ?? false
);
